import { render, staticRenderFns } from "./ModalDeleteTransaction.vue?vue&type=template&id=2b9ba063&"
import script from "./ModalDeleteTransaction.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports